import { $, $$ } from 'utils/dom';

class CountdownTimer {
  constructor(countdown) {
    this.countdown = countdown;
    this.timeStamp = countdown.getAttribute('data-enddate');
    this.hoursDigit = $('.o-countdown__digit--hours', countdown);
    this.minutesDigit = $('.o-countdown__digit--minutes', countdown);
    this.secondsDigit = $('.o-countdown__digit--seconds', countdown);
  }

  setToZero(countdown) {
    const digits = $$('.o-countdown__digit');

    digits.forEach(digit => {
      digit.textContent = `00`;
    });
  }

  setDisplayTime(remainingTime) {
    // Translate remaining time into a readable format
    const seconds = Math.floor(remainingTime % 60);
    const minutes = Math.floor((remainingTime / 60) % 60);
    const hours = Math.floor(remainingTime / (60 * 60));

    // Add a leading zero if hours/minutes/seconds < 0
    const minutesWithLeadingZero =
      minutes.toString().length < 2 ? ('0' + minutes).slice(-2) : minutes;
    const hoursWithLeadingZero =
      hours.toString().length < 2 ? ('0' + hours).slice(-2) : hours;
    const secondsWithLeadingZero =
      seconds.toString().length < 2 ? ('0' + seconds).slice(-2) : seconds;

    this.hoursDigit.textContent = hoursWithLeadingZero;
    this.minutesDigit.textContent = minutesWithLeadingZero;
    this.secondsDigit.textContent = secondsWithLeadingZero;
  }

  interval() {
    const intervalId = setInterval(() => {
      const remainingTime = Math.round(this.timeStamp - Date.now() / 1000);

      if (remainingTime < 0) {
        clearInterval(intervalId);
        this.setToZero(this.countdown);
      } else {
        this.setDisplayTime(remainingTime, this.countdown);
      }
    }, 1000);
  }

  init() {
    this.interval();
  }
}

const countdowns = $$('.o-countdown');
if (countdowns.length !== 0) {
  countdowns.forEach(countdown => new CountdownTimer(countdown).init());
}
